import {
    CANDIDATE_ADD_PROJECT_REQUEST,
    CANDIDATE_ADD_PROJECT_SUCCESS,
    CANDIDATE_ADD_PROJECT_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

export const CandidateAddProjectAction = (data,navigate) => {
    return function (dispatch) {
      dispatch({
        type: CANDIDATE_ADD_PROJECT_REQUEST,
        payload: true,
      });
      
      return new Promise((resolve,reject) => {
        let OPTION = {
          url: `${process.env.REACT_APP_API_PATH}/ebench/add_project`,
          method: "POST",
          data: data,
          headers: {
              "content-Type": "multipart/form-data",
          },
        };
  
        axios(OPTION)
          .then((res) => {
            dispatch(AddCandidateProjectPre(res.data));
            resolve(res.data)
            toast.success('Project Added Successfully')
            setTimeout(()=>{
              // window.location.href = "/candidate_dashboard";
  
              navigate('/candidate_dashboard')
            },1500)
          })
          .catch((error) => {
            reject(error);

            toast.error(error.response.data.status.message);
            dispatch({
              type: CANDIDATE_ADD_PROJECT_FAIL,
              payload: false,
              error: error,         
            });
            // toast.error("Failed To Add Project!");
          });
      })
      
    };
  };

  export const AddCandidateProjectPre = (data) => {
    // toast.success(" Project added Successfully!");
    return {
      type: CANDIDATE_ADD_PROJECT_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };